import { useUserOrganization } from '@modules-deprecated/app/organization'
import { SubscriptionPlan } from '@modules-deprecated/app/organization/enums/subscriptionPlan'

export const useIsEInvoicingOnly = () => {
  const { organization } = useUserOrganization()

  return ([SubscriptionPlan.EBPFree, SubscriptionPlan.IToolFree, SubscriptionPlan.QuadraFree] as any[]).includes(
    organization?.subscriptionProductPlan,
  )
}
